import { memo } from 'react';
import classnames from 'classnames';
import { Badge, Text } from '@Sage/hoi-poi-ui';
import { BaseReactCell } from '@Sage/ssm-web5';
import { getBackendBoolean } from '@Sage/ssm-utils/backendScalars';

import './ProductUnitRelationNameCell.scss';

const ProductUnitRelationNameCell = memo((props) => {
    const { data, value, colDef } = props;
    const baseBadgeLabel = colDef?.cellRendererParams?.baseBadgeLabel ?? '';
    const showBaseBadge = getBackendBoolean(data?.isBase) && Boolean(baseBadgeLabel);

    return (
        <BaseReactCell data={data} {...props}>
            <div className="product-unit-relation-name-cell">
                <Text
                    type="body"
                    className="product-unit-relation-name-cell__name"
                    isTruncated
                    useTooltip
                >
                    {value ?? ''}
                </Text>
                {showBaseBadge ? (
                    <Badge
                        type="semanticInfo"
                        className={classnames('product-unit-relation-name-cell__badge')}
                        isTruncated
                        useTooltip
                    >
                        {baseBadgeLabel}
                    </Badge>
                ) : null}
            </div>
        </BaseReactCell>
    );
});

ProductUnitRelationNameCell.displayName = 'ProductUnitRelationNameCell';

export default ProductUnitRelationNameCell;
